import Api from '@teko/api';
import { accessTokenInterceptor, handleResponseUnauthorizedInterceptor } from '@teko/auth';
import { requestDurationTrackingInterceptor, responseDurationTrackingInterceptor, trackCustomEvent } from '@teko/tracking';
import { cleanObject } from '@teko/utils';
import { isServerless } from './helpers.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_SEARCH_DATA = {
  page: 0,
  pageSize: 0,
  total: 0
};
class DiscoveryService {
  constructor(discoveryApiUrl, terminalId, language, location) {
    this.location = location;
    this.discoveryApi = new Api(discoveryApiUrl);
    this.terminalId = terminalId;
    this.discoveryApi.addInterceptor(accessTokenInterceptor);
    this.discoveryApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    !!isServerless() && this.discoveryApi.addInterceptor(requestDurationTrackingInterceptor);
    !!isServerless() && this.discoveryApi.addResponseInterceptor(responseDurationTrackingInterceptor);
    this.discoveryApi.addResponseInterceptor(handleResponseUnauthorizedInterceptor);
  }
  getTerminalId() {
    return this.terminalId;
  }
  get baseParams() {
    return cleanObject({
      terminalId: this.terminalId,
      location: this.location
    });
  }
  async search(payload, searchAlgoHeaderValue) {
    try {
      const { data } = await this.discoveryApi.post("/search-skus-v2", __spreadValues(__spreadValues({}, this.baseParams), payload), {
        headers: !!searchAlgoHeaderValue ? {
          "X-Enable-Search-Algorithm": searchAlgoHeaderValue
        } : {}
      });
      return (data == null ? void 0 : data.data) || DEFAULT_SEARCH_DATA;
    } catch (error) {
      const err = error;
      const failureInfo = {
        endpoint: "/search-skus-v2",
        terminalId: this.terminalId,
        code: err == null ? void 0 : err.code,
        message: err == null ? void 0 : err.message,
        response: err == null ? void 0 : err.response
      };
      const win = typeof window !== "undefined" ? window : void 0;
      if (typeof (win == null ? void 0 : win.track) === "function") {
        trackCustomEvent("searchSkusV2Failed", {
          action: "apiError",
          category: "teko-web",
          label: JSON.stringify(failureInfo),
          property: "search-skus-v2"
        });
      } else {
        console.log("[search-skus-v2] request failed", failureInfo);
      }
      throw error;
    }
  }
}

export { DiscoveryService };
